
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-navy text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Bio Section */}
          <div className="md:col-span-2">
            <h3 className="font-sora font-bold text-2xl mb-6 text-white">Henry Adebisi</h3>
            <p className="text-gray-300 mb-8 leading-relaxed text-lg">
              Finance & Strategy Leader specializing in fintech innovation, strategic finance, and sustainable business growth across Africa. 
              Building financial systems and investment frameworks that help African businesses scale across borders.
            </p>
            <div className="flex space-x-8">
              <a 
                href="https://www.linkedin.com/in/henry-adebisi-311049b1/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gold hover:text-white transition-colors duration-300 transform hover:scale-110"
              >
                <i className="ri-linkedin-fill text-2xl"></i>
              </a>
              <a 
                href="https://x.com/henryadebc?s=21" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gold hover:text-white transition-colors duration-300 transform hover:scale-110"
              >
                <i className="ri-twitter-x-fill text-2xl"></i>
              </a>
              <a 
                href="mailto:henry@afristakes.com"
                className="text-gold hover:text-white transition-colors duration-300 transform hover:scale-110"
              >
                <i className="ri-mail-fill text-2xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-sora font-bold text-xl mb-6 text-white">Quick Links</h4>
            <div className="space-y-4">
              <Link to="/about" className="block text-gray-300 hover:text-gold transition-colors duration-300 text-lg">
                About Henry
              </Link>
              <Link to="/experience" className="block text-gray-300 hover:text-gold transition-colors duration-300 text-lg">
                Experience
              </Link>
              <Link to="/ventures" className="block text-gray-300 hover:text-gold transition-colors duration-300 text-lg">
                Ventures
              </Link>
              <Link to="/writing" className="block text-gray-300 hover:text-gold transition-colors duration-300 text-lg">
                Articles
              </Link>
              <Link to="/speaking" className="block text-gray-300 hover:text-gold transition-colors duration-300 text-lg">
                Speaking
              </Link>
              <Link to="/contact" className="block text-gray-300 hover:text-gold transition-colors duration-300 text-lg">
                Contact
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-600 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-base">
            © 2024 Henry Adebisi. All rights reserved.
          </p>
          <div className="flex space-x-8 mt-6 md:mt-0">
            <Link to="/terms" className="text-gray-400 hover:text-gold text-base transition-colors duration-300">
              Terms
            </Link>
            <Link to="/privacy" className="text-gray-400 hover:text-gold text-base transition-colors duration-300">
              Privacy
            </Link>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-gold text-base transition-colors duration-300"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
